import React from "react";
import { Modal } from "react-bootstrap";

import closeIcon from "Assets/images/colse-pdf.png";
import styles from "./PolicyPreviewModal.module.scss";

const PolicyPreviewModal = ({ documentUrl, onHide }) => (
  <Modal className="pdf-viewer-class" fullscreen show={Boolean(documentUrl)} onHide={onHide}>
    <Modal.Header className="border-0 p-5 d-flex justify-content-end">
      <img
        src={closeIcon}
        alt="Close policy preview"
        width={20}
        height={20}
        className={styles.closeButton}
        onClick={onHide}
      />
    </Modal.Header>
    <Modal.Body className="p-0">
      {documentUrl && (
        <iframe
          title="Policy PDF preview"
          src={`${documentUrl}#toolbar=0&navpanes=0&scrollbar=0`}
          className={styles.pdfViewer}
        />
      )}
    </Modal.Body>
  </Modal>
);

export default PolicyPreviewModal;
